import React from 'react';
import { Button } from 'react-bootstrap';

const mockLines = [
  {
    type: "Mano de obra",
    concept: "Mano de obra",
    time: 2.5,
    price: 30.0,
    quantity: 1,
    discount: 0,
  },
]

const lineTypes = {
  "piece": "Pieza",
  "workforce": "Mano de obra"
}

const renderTotal = function (element) {
  let discount = 1;
  if (element.discount) {
    discount = 1 - element.discount / 100;
  }

  return parseFloat(parseFloat(element.quantity) * parseFloat(element.price).toFixed(2) * discount * parseFloat(1.21) ).toFixed(2);
}

class BudgetLineList extends React.Component {

  cleanLine(serviceLines, idx) {
    this.props.cleanServiceLine(serviceLines, idx);
  }

  render() {
    let serviceLines = this.props.lines || [];
    let role = this.props.role;

    let lines = serviceLines.map((el, idx) => (
      <tr key={idx}>
        <td scope="row"></td>
        <td>{lineTypes[el.type] ? lineTypes[el.type] : el.type}</td>
        <td>{el.concept}</td>
        <td>{parseFloat(el.price).toFixed(2)} €</td>
        <td>{el.quantity}</td>
        <td>{el.discount ? parseFloat(el.discount).toFixed(2) + " %" : "-"}</td>
        <td>{renderTotal(el)} €</td>
        <td>{(role === 'BUBOCAR' || role === 'AUTOCARE') && !this.props.isUpgrade && <Button bsStyle="warning" onClick={this.cleanLine.bind(this, serviceLines, idx)}>Eliminar</Button>}</td>
      </tr>
    )
    )


    return (
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th></th>
              <th>Tipo</th>
              <th>Concepto</th>

              <th>Precio</th>
              <th>Cantidad</th>
              <th>Descuento</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {lines}
          </tbody>
        </table>
      </div>
    )
  }
};

export default BudgetLineList;


// WEBPACK FOOTER //
// ./src/components/BudgetLinesList/index.js